import IRoomForm from '@/models/RoomFrom'
import { IRoom } from '@/models/IRoom'
import createAxios from './config/configureAxios'
import { API_URL } from './config/consts'
import { Admin } from '@/models/Admin'
import { IStudent } from '../models/IStudent'

const axios = createAxios({
  baseURL: API_URL + '/api/v1'
})

export const setAuthorization = (token: string) => {
  axios.defaults.headers.common['Authorization'] = token
}

export const api = {
  rooms: {
    create: (payload: IRoomForm) => axios.post<IRoom>(`/admin/rooms`, payload),
    delete: (id: string) => axios.delete<IRoom>(`/admin/rooms/${id}`),
    update: (id: string, payload: IRoomForm) => axios.put<IRoom>(`/admin/rooms/${id}`, payload),
    hide: (id: string, payload: { hide: boolean }) =>
      axios.patch(`/admin/rooms/${id}/visibility`, payload),
    findAll: () => axios.get<IRoom[]>('/rooms')
  },
  admin_students: {
    register_by_admin: (student: IStudent, roomId: string) =>
      axios.post<IRoom>(`/admin/rooms/${roomId}/student`, student),
    update_by_admin: (student: IStudent, roomId: string, studentId: string) =>
      axios.put<IRoom>(`/admin/rooms/${roomId}/student/${studentId}`, student),
    delete_by_admin: (roomId: string, studentId: string) =>
      axios.delete<IRoom>(`/admin/rooms/${roomId}/student/${studentId}`)
  },
  students: {
    remove_student: (roomId: string, studentId: string, userId: string) =>
      axios.delete(`/registration/rooms/${roomId}/student/${studentId}`, {
        headers: { userId }
      }),
    register_student: (roomId: string, student: IStudent, userId: string) =>
      axios.post(`/registration/rooms/${roomId}/student`, student, { headers: { userId } }),
    reserve_room: (roomId: string, userId: string) =>
      axios.post(`/registration/rooms/${roomId}/reserve`, null, { headers: { userId } })
  },
  admins: {
    verifyAndCreate: () => axios.post('/admins'),
    accept: (email: string) => axios.put(`/admins/accept/${email}`),
    remove: (email: string) => axios.delete(`/admins/${email}`),
    fetchAll: () => axios.get<Admin[]>('/admins'),
    findMe: () => axios.get<Admin>('/admins/me')
  },
  config: {
    get: () => axios.get('/config'),
    getFull: () => axios.get('/config/full'),
    set: (config: any) => axios.put('/config', config),
    checkRegistrationUrl: (url: string) =>
      axios.post<{ isValidRegistrationUrl: boolean }>('/config/check-registration-url', { url })
  }
}
